(function () {

  let accordionBtns;
  let wasMobile;

  window.addEventListener('DOMContentLoaded', init);

  function init() {
    accordionBtns = document.getElementsByClassName('footer-block__expand-btn');

    let k = 0;
    while (k < accordionBtns.length) {
      const accordionBtn = accordionBtns[k];
      accordionBtn.addEventListener('click', toggleAccordion(accordionBtn));
      k += 1;
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (wasMobile !== isMobile()) {
          wasMobile = !wasMobile;
          let n = 0;
          while (n < accordionBtns.length) {
            const block = accordionBtns[n].closest('.footer-block');
            const list = block.querySelector('.footer-block__details-content');
            list.style.height = '';
            block.classList.remove('is-expanded');
            n += 1;
          }

        }
      }, 200);
    });
  }

  function toggleAccordion(btn) {
    return function () {
      if (!isMobile()) {
        return;
      }

      const block = btn.closest('.footer-block');
      const list = block.querySelector('.footer-block__details-content');
      console.log({block, list});

      if (block.classList.contains('is-expanded')) {
        list.style.height = '';
        block.classList.remove('is-expanded');
      } else {
        getHeightOfHiddenList(list, (height, err) => {
          if (err) throw err;
          list.style.height = `${height}px`;
          block.classList.add('is-expanded');
        });
      }
    };
  }

  function isMobile() {
    return window.innerWidth < 750;
  }

  function getHeightOfHiddenList(list, cb) {
    try {
      const clone = list.cloneNode(true);
      clone.style.position = 'absolute';
      clone.style.left = '0';
      clone.style.top = '0';
      clone.style.right = '0';
      clone.style.width = '100%';
      clone.style.height = 'auto';
      list.parentElement.appendChild(clone);
      window.requestAnimationFrame(() => {
        setTimeout(() => {
          const height = clone.getBoundingClientRect().height;
          list.parentElement.removeChild(clone);
          console.log({height});
          return cb(height);
        }, 0);
      });
    } catch (exception) {
      return cb(undefined, exception);
    }
  }

})();
